


















































































































































import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
// TODO: 待优化组件
@Component({})
export default class ActivityCycle extends Vue {
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) readonly: boolean; // 是否只读模式
  @Prop({ default: "" }) value: String; // 一次性还是周期性
  @Prop({
    default: () => ({
      expression: "1-1-1", // 时间表达式，null 为未选择
      timeRange: ["10:00:00", "23:59:59"] // 时间的详细时间
    })
  })
  options: Object; // 配置默认数据，readOnly的时候读相应的数

  private cycleForm = {
    cycleFrequency: ["1"],
    cycleTime: ["10:00:00", "23:59:59"],
    cycleIntervalNum: "1", // 传值的时候，至少是1，表示每周
    cycleFreType: "week"
  };
  private showCycleVisible = false;
  private acFrequencyType = "0";

  get DEFAULT_TIMERANGE() {
    return ["10:00:00", "23:59:59"];
  }
  get cycleOptions() {
    return [
      {
        label: "月",
        value: "month"
      },
      {
        label: "周",
        value: "week"
      }
    ];
  }
  get dateWeek() {
    const nums = ["一", "二", "三", "四", "五", "六", "日"];
    return nums.map((item, i) => {
      // 最后的日为1
      return {
        label: item,
        value: String(i + 1)
      };
    });
  }
  get dateWeekValues() {
    return this.dateWeek.map(({ value }) => value);
  }
  get dateMonth() {
    const nums = 31;
    let arr = [];
    for (let i = 1; i <= nums; i++) {
      arr.push({
        label: i,
        value: String(i)
      });
    }
    return arr;
  }
  get dateMonthValues() {
    return this.dateMonth.map(({ value }) => value);
  }

  get acCycleRules() {
    const propList = ["cycleFrequency", "cycleTime"];
    return this.fRules(propList, "必选");
  }
  get defaultFrequency() {
    return ["1"];
  }

  @Watch("acFrequencyType")
  handleChangeFre(val) {
    if (val === "2") {
      this.changeFrequency();
    }
    this.$emit("input", val);
  }

  @Watch("cycleForm", { deep: true })
  handleChangeCycleForm(val) {
    let expresstion = this.fTimeExpresstion();
    // 监听每一次变化，抛出处理后的时间表达式，和时间范围
    const { cycleTime } = this.cycleForm;
    const emitDataObj = {
      expresstion,
      timeRange: cycleTime
    };

    this.$emit("change", emitDataObj);
  }

  @Watch("value", { immediate: true })
  handleChangeFrequency(val) {
    this.acFrequencyType = val;
  }
  // @Watch("options")
  // handleOptions(valObj, oldObj) {
  //   console.log(valObj, "handleOptions", oldObj);
  //   this.setInitValObj(valObj);
  // }

  reset() {
    this.cycleForm = {
      cycleIntervalNum: "1",
      cycleFrequency: this.defaultFrequency,
      cycleTime: this.DEFAULT_TIMERANGE,
      cycleFreType: "week"
    };
  }

  mounted() {
    // FIXME: this.options不能直接在初始化时候赋值，因为子组件在没有获取值时，可能已经被初始化
    this.setInitValObj(this.options);
  }

  handleChangeCycleType(val) {
    this.cycleForm.cycleFrequency = this.defaultFrequency;
  }
  handleCycleDateChange(val) {
    if (val === `1`) {
      // 切换到周期性，默认弹起弹窗
      this.changeFrequency();
    }
  }

  async handleChangeCycleDate() {
    await (this.$refs.cycleForm as any).validate(valid => {
      if (valid) {
        this.showCycleVisible = false;
        console.log("submit");
      } else {
        console.log("error submit!!");
        return false;
      }
    });
    // 成功之后关闭弹窗
  }

  setInitValObj(options) {
    this.reset();
    const { expression = null, timeRange } = options;
    if (!expression) return;
    const timeExpressionObj = this.dfTimeExpresstion(expression);
    this.cycleForm = {
      cycleIntervalNum: (timeExpressionObj && timeExpressionObj.internal) || "",
      cycleFrequency:
        (timeExpressionObj && timeExpressionObj.value) || this.defaultFrequency, // 反解
      cycleTime: timeRange[0] ? timeRange : this.DEFAULT_TIMERANGE,
      cycleFreType: (timeExpressionObj && timeExpressionObj.label) || "week" // 反解
    };
  }
  getDateWeekLabel(val) {
    const data = this.dateWeek;
    return data && data.find(({ value }) => value == val).label;
  }
  changeFrequency() {
    // acFrequency应该是Type"2"
    // 修改活动周期弹窗弹起来
    this.showCycleVisible = true;
  }
  fTimeExpresstion() {
    const { cycleFreType, cycleFrequency, cycleIntervalNum } = this.cycleForm;
    const type = cycleFreType;
    let frequency = JSON.parse(JSON.stringify(cycleFrequency));
    // w-n(w: 1 / m: 2)-w/m(1,2,3...n)       短横线隔开（w:week,m:month)。每几(周/月)——周/月（1表示周，2表示月）——周几/月几号
    try {
      frequency = frequency.sort((a, b) => Number(a) - Number(b));
    } catch (error) {
      console.warn(error);
    }
    let values = frequency.join(",");
    // 如果没有选日期，values就是null，方便外部判断为空
    if (!values) {
      return null;
    }
    let isWeekOrMonth = type === "week";
    return `${cycleIntervalNum || 1}-${type === "week" ? 1 : 2}-${values}`;
  }
  dfTimeExpresstion(str) {
    // 2-1-2,4,5
    if (!str) return;
    str = String(str);
    const strData = str.split("-");
    // ['2', '1', '2,4,5']
    if (strData && strData.length != 3) {
      console.warn(`Time Expresstion error, data: ${str}`);
      return {
        label: "week",
        value: [],
        internal: ""
      };
    }
    // 第二位，1表示周，2表示月
    // ['2', '1', '2,4,5']
    const internalNum = String(strData[0]); // 间隔数
    const isExpresstionWeek = String(strData[1]) === "1";
    const numList = strData[2].split(",");
    return {
      label: !isExpresstionWeek ? "month" : "week",
      value: numList || [],
      internal: internalNum
    };
  }

  fSelectDate(date) {
    const {
      cycleFrequency,
      cycleFreType,
      cycleIntervalNum = ""
    } = this.cycleForm;
    let dataList = JSON.parse(JSON.stringify(cycleFrequency));
    dataList = dataList.sort((a, b) => a - b);
    let suffixStr = "";
    let dateStr = "";
    if (cycleFreType === `month`) {
      suffixStr = `每隔 ${cycleIntervalNum || ""} 月的 `;
      dateStr = dataList
        .map(item => {
          const getLabel = this.dateMonth.find(({ value }) => item === value);
          if (getLabel) {
            return `${getLabel.label}号`;
          } else {
            return "";
          }
        })
        .join("、");
    }

    if (cycleFreType === `week`) {
      suffixStr = `每隔 ${cycleIntervalNum || ""} 周的 `;
      dateStr = dataList
        .map(item => {
          const getLabel = this.dateWeek.find(({ value }) => item === value);
          if (getLabel) {
            return `星期${getLabel.label}`;
          } else {
            return "";
          }
        })
        .join("、");
    }
    return suffixStr + (dateStr ? dateStr + " 的" : dateStr);
  }
  fRules(props, message = "必填") {
    const commonRule = [
      {
        required: true,
        message,
        trigger: "blur"
      }
    ];
    let rulesObj = {};
    for (let item of props) {
      rulesObj[item] = commonRule;
    }
    return rulesObj;
  }
  validIntNumRange = (rule, value, callback) => {
    const isValid = /^[1-9][0-9]*$/.test(String(value));
    if (Number(value) > 99) {
      callback(new Error("请输入1-99的正数"));
    } else if (isValid) {
      callback();
    } else {
      callback(new Error("请输入1-99的正数"));
    }
  };
}
